// cssをインポート
import "../scss/styles.scss";

// モジュールjsインポート
//require('./common');

import { common } from './common';

common('do');
